module.exports = __webpack_public_path__ + "assets/img/icon10-menu.3403235c.svg";